import React from "react"
import * as styles from "./left-header-text.module.scss"
import { Container, Row, Col } from "react-bootstrap";

export default function LeftHeaderTextRow(props) {
  return <Container>
    <Row>
      <Col xs={12}>
        <div className={styles.wrapper}>
          <div className={styles.header}>{props.header}</div>
          <div 
            className={styles.text} 
            dangerouslySetInnerHTML={{ __html: props.text }}
          ></div>
        </div>
      </Col>
    </Row>
  </Container>
}
